import React, { useEffect, useState } from 'react';
import PageHeader from "../../components/page-header";
import NewSideBar from "../../components/side-bar/new-sidebar";
import { apiUrl, pageUrl, protocol } from "../../utils/url";
import { useDispatch, useSelector } from "react-redux";
import copyComponent from "../../assets/img/copy-clipboard.svg";
import { toast } from "react-toastify";
import plusIcon from "../../assets/img/thin-plus-icon.svg";
import gearBlackIcon from "../../assets/img/gear.svg";
import dragIcon from "../../assets/img/page/drag-icon.svg";
import BlockIcon from "../../assets/img/page/blockicon.svg";
import gearPageIcon from "../../assets/img/page/gear.svg";
import trashIcon from "../../assets/img/page/trash.svg";
import { CustomizeProductModal } from './product-settings';
import { hideLoader, showLoader } from '../loader';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ThreeBoxPage from './product-settings/product-tabs/product-section/three-box-page';
import GlobalblockPage from './product-settings/product-tabs/product-section/global-page';
import FaqsPage from './product-settings/product-tabs/product-section/faq-page';
import ReviewPage from './product-settings/product-tabs/product-section/review-page';
import ConfirmationModal from '../confirmation-modal';
import ExportStep1 from './product-settings/product-tabs/exports/export-steps';
import ExportSteps from './product-settings/product-tabs/exports/export-steps';
import Logo from './product-settings/product-tabs/product-section/logo';
import desktopIcon from "../../assets/img/desktop-icon.svg";
import mobileIcon from "../../assets/img/mobile-icon.svg";
import CustomCode from './product-settings/product-tabs/product-section/custom-code';
import ProductBlocks from './product-settings/blocks/product-block';

let script_tag = `<script src="https://sortablejs.github.io/Sortable/Sortable.js"></script>`
const blockSortable = (setIframeURL,slug, product_slug) => {
    const el = document.querySelector('.product-blocks-main')
    const image = document.querySelector('#drag')
    let folders_sortable = Sortable?.create(el, {
        animation: 150,
        handle: '#drag',
        draggable: '.product-block',
        onUpdate: (event) => {
            let blocks = [];
            $('.product-blocks-main> .product-block').each((i, elm) => {
                let block = {
                    block_id: elm.dataset.block,
                    order_no: i
                };
                blocks.push(block);
            })

            if (blocks.length > 0)
                $.ajax({
                    type: 'POST',
                    url: `${apiUrl}/ProductFlow/sort`,
                    data: {
                        request_type: 'order',
                        blocks,
                        project: localStorage?.slug,
                        product: product_slug
                    },
                    headers: {
                        'Authorization': `Bearer ${localStorage?.getItem("token")}`
                    },
                    dataType: 'json',
                    success: (response) => {
                        setTimeout(() => {
                            setIframeURL(protocol + '' + slug + '.' +pageUrl  + '/' +  product_slug   + '?iframe=1&v=' + Math.random(100));
                        }, 1000);
                    }
                });
        }
    });
}

function EditProduct(props) {
    const { productData, iframeURL, iframeIndex, productSlug, campaign_id, setIframeURL, setIframeIndex, editProduct } = props;
    const location = useLocation();
    const history = useHistory();
    const [error, setError] = useState([]);
    // const { edit, product_id } = location?.state || {};
    var product_id = campaign_id;
    // console.log("product_id",product_id)
    // useEffect(()=>{
    //     if (!product_id) {
    //         history.push(basePath + '/campaigns')
    //     }
    // },[])
    const { basePath, slug } = useSelector(state => state?.slugReducer);
    const [showModal, setShowModal] = useState({show:false,from:null});
    // const [productSlug, setProductSlug] = useState();
    const [showSectionChildModal, setShowSectionChildModal] = useState();
    // const [productBlocks, setProductBlocks] = useState([]);
    // const [iframeURL, setIframeURL] = useState(1);
    // const [iframeIndex, setIframeIndex] = useState(1);
    // const [productData, setProductData] = useState({});
    const productBlocks = useSelector(state => state?.productBlockReducer)
    const [confirmationModalShow, setconfirmationModalShow] = useState({ show: false, text: null });
    const copyingText = (text) => navigator.clipboard.writeText(text).then((r => toast.success("Successfully Copied")));
    const draggableIcon = () => <img src={dragIcon} id="drag" className="me-3 cursor-grab" alt="" />
    const showProductsSectionModal = (from) => {
        setError([])
        setShowModal({show:true,from:from})
    };
    const [showPreviewScreen,setShowPreviewScreen] = useState("desktop");
    const close = () => {
        setError(null);
        setShowSectionChildModal(false)
    };
    // const editProduct = (product_id) => {
    //     const api = apiUrl + "/ProductFlow/edit/" + product_id;
    //     showLoader()
    //         var myHeaders = new Headers();
    //         myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
    //         const setOptions = {
    //             method: "GET",
    //             headers: myHeaders,
    //         }
    //         fetch(api, setOptions)
    //         .then(async (res) => {
    //             const response = await res?.json();
    //             if (response?.status_code == 200) {
    //                 setProductData(response?.data)
    //                 setProductSlug(response?.data?.slug)
    //                 setProductBlocks(response?.data?.product_blocks)
    //                 setIframeURL(protocol + '' + slug + '.' +pageUrl  + '/' + ( response?.data?.slug )  + '?iframe=1');
    //                 setIframeIndex(iframeIndex + 1);
    //             }
    //         hideLoader();
    //       }).catch(() => {
    //         hideLoader();
    //       });
    //   }
    //   useEffect(() => {
    //     console.log("editProduct true")
    //     if (product_id) {
    //       editProduct(product_id);
    //     }else if(localStorage?.product_id){
    //       editProduct(localStorage.getItem("product_id"));
    //     }
    //     }, [edit]);
    const handleSubmit = (values,tab) =>{
        const api = apiUrl + "/ProductFlow/create-block";
        showLoader()
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            const formdata = new FormData();
            formdata.append("project", slug);
            formdata.append("block", tab);
            formdata.append("product_slug", productData?.slug);
            if(tab == 'three_box'){
                formdata.append('boxes', JSON.stringify(values));
            }else if(tab == 'faq'){
                formdata.append('faqs', JSON.stringify(values));
            }else if(tab == 'reviews'){
                formdata.append('reviews', JSON.stringify(values));
            }else if(tab == 'pricing'){
                formdata.append('pricing', JSON.stringify(values));
            }else if(tab == 'logo'){
                formdata.append('logo', JSON.stringify(values));
            }
            else{
                for (const key in values) {
                    if (Object.hasOwnProperty.call(values, key)) {
                        formdata.append(key, values[key]);
                    }
                }
            }
            const setOptions = {
                method: "POST",
                body: formdata,
                headers: myHeaders,
            }
            fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    setShowSectionChildModal(false)
                    setTimeout(() => {
                        editProduct(product_id)
                        setIframeURL(protocol + '' + slug + '.' +pageUrl  + '/' + ( response?.data?.slug )  + '?iframe=1');
                        setIframeIndex(iframeIndex + 1);
                        hideLoader();
                    }, 1000);
                    toast.success(response?.status_message)
                }else{
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                        $(".modal-body").scrollTop(0);
                    hideLoader();
                }
            hideLoader();
          }).catch(() => {
            hideLoader();
          });
    }
    const handleUpdate = (values,tab,block_id) =>{
        const api = apiUrl + "/ProductFlow/update-block";
        showLoader()
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            const formdata = new FormData();
            formdata.append("project", slug);
            formdata.append("block", tab);
            formdata.append("product_slug", productData?.slug);
            formdata.append("block_id", block_id);
            if(tab == 'three_box'){
                formdata.append('boxes', JSON.stringify(values));
            }else if(tab == 'faq'){
                formdata.append('faqs', JSON.stringify(values));
            }else if(tab == 'reviews'){
                formdata.append('reviews', JSON.stringify(values));
            }else if(tab == 'pricing'){
                formdata.append('pricing', JSON.stringify(values));
            }else if(tab == 'logo'){
                formdata.append('logo', JSON.stringify(values));
            }else{
                for (const key in values) {
                    if (Object.hasOwnProperty.call(values, key)) {
                        formdata.append(key, values[key]);
                    }
                }
            }
            const setOptions = {
                method: "POST",
                body: formdata,
                headers: myHeaders,
            }
            fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    setShowSectionChildModal(false)
                    setTimeout(() => {
                        editProduct(product_id)
                        setIframeURL(protocol + '' + slug + '.' +pageUrl  + '/' + ( response?.data?.slug )  + '?iframe=1');
                        setIframeIndex(iframeIndex + 1);
                        hideLoader();
                    }, 1000);
                    toast.success(response?.status_message)
                }else{
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                        $(".modal-body").scrollTop(0);
                    hideLoader();
                }
            hideLoader();
          }).catch(() => {
            hideLoader();
          });
    }
    const editModal = (e, data) => {
        setError([])
        if (data?.type == "three_box"){
            setShowSectionChildModal({
                show: true,
                id: e.target.dataset?.id,
                meta: data?.meta,
                type:"threeBox"
            })
        }else{
            setShowSectionChildModal({
                show: true,
                id: e.target.dataset?.id,
                meta: data?.meta,
                type:data?.type
            })
        }
    }
    const confirmedDeleteBlock = (e) => {
        // e.preventDefault();
        showLoader()
        if (confirmationModalShow?.id) {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            var requestOptions = {
            };
            var api = `${apiUrl}/ProductFlow/delete-block/${confirmationModalShow?.id}`
            requestOptions = {
                method: 'DELETE',
                headers: myHeaders,
                redirect: 'follow'
            }
            fetch(api, requestOptions)
                .then(async (res) => {
                    const response = await res?.json();
                    if (response?.status_code == 200) {
                        editProduct(product_id);
                    }
                    else {
                        toast.error(response?.status_message)
                        hideLoader()
                    }
                    setconfirmationModalShow({ show: false, text: null, id: null })
                })
                .catch(() => {
                    setconfirmationModalShow({ show: false, text: null, id: null })
                    hideLoader()
                })
        }

    }
    const onDelete = (id) => setconfirmationModalShow({ show: true, text: "Are you sure you want to delete this block?", id: id, callBackTo: "delete" })

    useEffect(() => {
        $("body").append(script_tag)

        $(document).ready(() => {

            setTimeout(() => {
                // folders sort
                if (productSlug) {
                    blockSortable(setIframeURL,slug,productSlug,iframeIndex,setIframeIndex)
                }
            }, 2000);
        })

    }, [productSlug])
    const togglePreviewScreen = (e) => {
        setShowPreviewScreen(e.target.value)
    };
  return (
    <>
          {/* <PageHeader /> */}
          <div className="page-editor-main"> 
                <NewSideBar/>

            <div className='main-cont'>
                <div className='Edit-area d-flex  flex-column'>
                    <div>
                    <h2 className='mainTitle'>Edit Campaign</h2>
                    <div className="Product-Editor mt-30px">
                        <button className="bg-blue" onClick={() => showProductsSectionModal('add_block')}>
                            <img src={plusIcon} alt="" width={10}/>
                            <span>Add Section</span>
                        </button>
                        <button className="bg-blue bg-gray" onClick={() => showProductsSectionModal('customize_product')}>
                            <img src={gearBlackIcon} width={14} alt="" />
                            <span >Campaign Settings</span>
                        </button>
                    </div>
                    <div className='product-blocks-main' id="product-blocks-main">
                    {productBlocks?.length > 0 && productBlocks?.map((val, index) => 
                        <ProductBlocks 
                            key={val.id}
                            val={val}
                            editModal={editModal}
                            onDelete={onDelete}
                            draggableIcon={draggableIcon}
                        />
                    )}
                    </div>
                    {/* <div className="editor-header d-flex align-items-center justify-content-start mt-20px">
                        <button className="bg-blue w-100" onClick={() => showProductsSectionModal('add_block')}>
                            <img src={plusIcon} alt="" width={10}/>
                            <span>Add Section</span>
                        </button>
                    </div> */}
                    </div>
                
                <div style={{minHeight:"50px",padding:"0 10px"}} className="bg-f3f3f3 border-12 d-flex w-100 mt-20px justify-content-between align-items-center ">
                    <div className='d-flex gap-2 align-items-center'>
                        <div class="counter"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none"><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" d="m3.425 7.65.51 1.02c.172.345.259.518.374.667.102.133.221.252.354.354.15.115.322.202.667.374l1.02.51-1.02.51c-.345.172-.518.259-.667.374a1.95 1.95 0 0 0-.354.354c-.115.15-.202.322-.374.667l-.51 1.02-.51-1.02c-.172-.345-.259-.518-.374-.667a1.95 1.95 0 0 0-.354-.354c-.15-.115-.322-.201-.667-.374l-1.02-.51 1.02-.51c.345-.172.518-.259.667-.374a1.95 1.95 0 0 0 .354-.354c.115-.15.202-.322.374-.667l.51-1.02ZM8.95.5l.766 1.992c.183.476.275.715.418.915.126.178.281.333.459.46.2.142.438.234.915.417l1.992.766-1.992.766c-.476.183-.715.275-.915.418a1.949 1.949 0 0 0-.46.459c-.142.2-.234.439-.417.915L8.95 9.6l-.766-1.992c-.183-.476-.275-.715-.418-.915a1.95 1.95 0 0 0-.459-.46c-.2-.142-.439-.234-.915-.417L4.4 5.05l1.992-.766c.476-.183.715-.275.915-.418a1.95 1.95 0 0 0 .46-.459c.142-.2.234-.439.417-.915L8.95.5Z"/></svg></div>
                        <span>Ready to Export?</span>
                    </div>
                    <button className="project-blue-btn" onClick={() => showProductsSectionModal('export')}>
                        <img src={plusIcon} alt="" width={10}/>
                        <span>Export Leads</span>
                    </button>
                </div>
                </div>
              

                <div className={`rightbar-u position-relative ${showPreviewScreen == 'mobile' ? 'mobile-screen-preview': null}`}>
                    <div className='d-flex align-items-center w-100 rightbar-first-half'>
                            <div class="toggle-input-checkbox w-auto">
                                <input type="radio" id="desktop_preview" name="planType"  style={{ display: "none" }} onChange={togglePreviewScreen} checked={showPreviewScreen == "desktop"}  value={"desktop"} />
                                <label for="desktop_preview"> <span > <img src={desktopIcon} alt="" /></span></label>
                                <input type="radio" id="mobile_preview" name="planType"  style={{ display: "none" }} onChange={togglePreviewScreen} checked={showPreviewScreen == "mobile"} value={"mobile"}  />
                                <label for="mobile_preview" > <span > <img src={mobileIcon} alt="" /> </span></label>
                            </div>
                            <a target="_blank" className='preview-page-button' href={iframeURL}>
                                Preview Page
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M1 11L11 1M11 1H4.33333M11 1V7.66667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </a>
                    </div>
                        <div className={`Product-preview-mobile ${showPreviewScreen == 'desktop' ? 'desktop-screen-preview': null}`}>
                            <iframe className='w-100 h-100' src={iframeURL} key={iframeIndex} frameBorder="0" ></iframe>
                            <div className="page-preview-loader">
                                <div className="spinner">
                                    <div className="bar1"></div>
                                    <div className="bar2"></div>
                                    <div className="bar3"></div>
                                    <div className="bar4"></div>
                                    <div className="bar5"></div>
                                    <div className="bar6"></div>
                                    <div className="bar7"></div>
                                    <div className="bar8"></div>
                                    <div className="bar9"></div>
                                    <div className="bar10"></div>
                                    <div className="bar11"></div>
                                    <div className="bar12"></div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        {confirmationModalShow?.show && <ConfirmationModal confirmationModalShow={confirmationModalShow} setShow={setconfirmationModalShow} callback={confirmedDeleteBlock} />}
        {/* {console.log("showSectionChildModal",showSectionChildModal)} */}
        {showModal.show && showModal.from == 'export' ? <ExportSteps product_id={product_id} show={showModal} setShow={setShowModal}/> :
        <CustomizeProductModal show={showModal} setShow={setShowModal} data={productData} setIframeURL={setIframeURL} iframeIndex={iframeIndex} setIframeIndex={setIframeIndex} editProduct={editProduct} product_id={product_id} setShowSectionChildModal={setShowSectionChildModal}/> }
        {showSectionChildModal?.type == 'threeBox' ? <ThreeBoxPage error={error} setError={setError} handleUpdate={handleUpdate} data={showSectionChildModal} showSectionChildModal={true} setShowSectionChildModal={setShowSectionChildModal} handleSubmit={handleSubmit} close={close}/> : null}
        {showSectionChildModal?.type == 'custom_code' ? <CustomCode error={error} setError={setError} handleUpdate={handleUpdate} data={showSectionChildModal} showSectionChildModal={true} setShowSectionChildModal={setShowSectionChildModal} handleSubmit={handleSubmit} close={close}/> : null}
        {/* {showSectionChildModal?.type == 'horizontal' && <GobalblockPage type={'horizontal'} error={error} setError={setError} showSectionChildModal={true && 'horizontal'} setShowSectionChildModal={setShowSectionChildModal} handleUpdate={handleUpdate} data={showSectionChildModal} handleSubmit={handleSubmit} close={close}/>} */}
        {/* {showSectionChildModal?.type == 'vertical' && <GobalblockPage data={showSectionChildModal} type={'vertical'} error={error} setError={setError} showSectionChildModal={true && 'vertical'} setShowSectionChildModal={setShowSectionChildModal} handleUpdate={handleUpdate} handleSubmit={handleSubmit} close={close}/>} */}
        {showSectionChildModal?.type == 'faq' && <FaqsPage  data={showSectionChildModal} showSectionChildModal={true} error={error} setError={setError} setShowSectionChildModal={setShowSectionChildModal} close={close} handleSubmit={handleSubmit} handleUpdate={handleUpdate}/>}
        {showSectionChildModal?.type == 'reviews' && <ReviewPage showSectionChildModal={true} error={error} setError={setError} setShowSectionChildModal={setShowSectionChildModal} close={close} handleSubmit={handleSubmit} handleUpdate={handleUpdate} data={showSectionChildModal}/>}
        {showSectionChildModal?.type == 'logo' && <Logo showSectionChildModal={true} error={error} setError={setError} setShowSectionChildModal={setShowSectionChildModal} close={close} handleSubmit={handleSubmit} handleUpdate={handleUpdate} data={showSectionChildModal}/>}
        {showSectionChildModal?.type && (showSectionChildModal?.type == 'large_text' || showSectionChildModal?.type == 'footer' || showSectionChildModal?.type == 'vertical' || showSectionChildModal?.type == 'horizontal' || showSectionChildModal?.type == 'pricing' || showSectionChildModal?.type == 'hero') ? <GlobalblockPage type={showSectionChildModal?.type} error={error} setError={setError} showSectionChildModal={true} setShowSectionChildModal={setShowSectionChildModal} close={close} handleSubmit={handleSubmit} handleUpdate={handleUpdate} data={showSectionChildModal}/>:null}
    </>
  )
}

export default EditProduct